const Background = () => import('views/bg/Background')
const MySession = () => import('views/bg/my/MySession')
const MyMessage = () => import('views/bg/my/MyMessage')
const MyApproval = () => import('views/bg/my/MyApproval')
const MyContact = () => import('views/bg/my/MyContact')
const MyApiKey = () => import('views/bg/my/MyApiKey')

export default {
  path: '/bg/account',
  redirect: '/bg',
  name: 'Account',
  title: '我的帐号',
  icon: 'el-icon-user',
  component: Background,
  meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] },
  children: [
    {
      path: '/bg/account/session',
      name: 'MySession',
      title: '在线会话',
      icon: 'el-icon-user',
      component: MySession,
      meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
    },
    {
      path: '/bg/account/api_key',
      name: 'ApiKey',
      title: 'ApiKey',
      icon: 'el-icon-user',
      component: MyApiKey,
      meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
    },
    {
      path: '/bg/account/message',
      name: 'MyMessage',
      title: '我的消息',
      icon: 'el-icon-user',
      component: MyMessage,
      meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
    },
    {
      path: '/bg/account/approval',
      name: 'MyApproval',
      title: '我的审批',
      icon: 'el-icon-user',
      component: MyApproval,
      meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
    },
    {
      path: '/bg/account/contact',
      name: 'MyContact',
      title: '联系人',
      icon: 'el-icon-user',
      component: MyContact,
      meta: { needAuth: true, roles: ['tnb_admin', 'tnb_user', 'tnb_disk'] }
    }
  ]
}
